/* START OF COMPILED CODE */
import Phaser from 'phaser';
import Win98Window from '../components/ui/Windows98Window';
import { createHopMovement} from "../util/HopMovement";
import { DebugCoordinates } from '../util/DebugCoordinates';
import { loadSceneSprites, createSceneAnimations } from '../util/Animations';
import PlayerCharacter from '../components/player/PlayerCharacter';
import { DialogueWindow } from '../components/ui/DialoguePanel';

export default class MainScene extends Phaser.Scene {
    constructor() {
        super("Main");

        /* START-USER-CTR-CODE */
        this.isHopping = false;
        this._randomHopEvent = null;
        this.isAnimating = false;
        this.windowOpen = false;
        /* END-USER-CTR-CODE */
    }
	/* START-USER-CODE */


    startRandomHopping() {
        if (!this._randomHopEvent) {
            this._randomHopEvent = this.time.addEvent({
                delay: 2000,
                callback: this.randomHop,
                callbackScope: this,
                loop: true
            });
        }
    }

    stopRandomHopping() {
        if (this._randomHopEvent) {
            this._randomHopEvent.remove();
            this._randomHopEvent = null;
        }
    }

    preload() {
        // All assets are pre-loaded by LoadingScene
    }

    async create() {
         this.cameras.main.setViewport(0, 0, 256, 192);
        
        
        // Create player animations
        PlayerCharacter.createAnimations(this);
        createSceneAnimations(this);
    
        // Get user's preferred color
        this.playerColor = await PlayerCharacter.getUserColor(this);
        this.game.events.on('menuAction', this.handleMenuAction, this); // Listen for events from the menu

        // Load background
        this.add.image(128, 96, 'rocky');
        this.slidingDoor = this.add.image(128, 96, 'sliding_door');
        this.add.image(128, 96, 'pad');

        // Create keyboard controls
        this.fKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.F);
        this.rKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.R);
        this.hKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.H);
        this.cKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.C);

        // Setup C key listener for window popup
        this.cKey.on('down', () => {
            if (!this.windowOpen) {
                this.openWindows98();
            }
        });

        // this.xKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.X);

        const bounds = this.add.rectangle(160, 123, 175, 90);
    
        this.movementBounds = {
            x: bounds.x - bounds.width/2,
            y: bounds.y - bounds.height/2,
            width: bounds.width,
            height: bounds.height
        };

        this.playlist = Phaser.Utils.Array.Shuffle(['bgm1', 'bgm2', 'bgm3']);
        this.currentTrack = 0;
    
        this.playCurrentTrack();

        this.soundFx = {
            rockSlide: this.sound.add('rock_slide', {
                volume: 0.8
            }),
            success: this.sound.add('success2', {
                volume: 0.3
            })
        };

        this.player = this.add.sprite(128, 120, `solagotchi_${this.playerColor}`);
        this.player.play(`${this.playerColor}_idle2`, true);
        this.hopInDirection = createHopMovement(this, this.player);
        this.startRandomHopping(); 
        
        
    }

    update() {
        if (this.rKey?.isDown) {
            this.animateRockDoor("River");
        }

        if (this.hKey?.isDown) {
            this.animateRockDoor("Beach");
        }

        if (this.fKey?.isDown) {
            this.animateRockDoor("Farm");
        }

        //  if (this.xKey?.isDown) {
        //     this.getInTheCrystal();
        //  }
    }

    randomHop() {
        const directions = ['n', 'ne', 'e', 'se', 's', 'sw', 'w', 'nw'];
        let attempts = 0;
        let success = false;
        
        while (!success && attempts < 4) {
            const randomDirection = directions[Math.floor(Math.random() * directions.length)];
            success = this.hopInDirection(randomDirection);
            attempts++;
        }
    }

    playCurrentTrack() {
        if (this.currentMusic) {
            this.currentMusic.stop();
        }
        this.currentMusic = this.sound.add(this.playlist[this.currentTrack]);
        this.currentMusic.volume = .6;
        this.currentMusic.play();
        
        this.currentMusic.once('complete', () => {
            this.currentTrack = (this.currentTrack + 1) % this.playlist.length;
            this.playCurrentTrack();
        });
    }

    openWindows98() {
        this.windowOpen = true;
        this.game.events.emit('forceCloseMenus');

        const popup = new Win98Window(
            this,
            130,
            95,
            'win98window',
            'You got alpha about a new coin, $CHI. To ape, or not to ape, that is the question!'
        );

        popup.setOkayCallback(() => {
            popup.destroy();
            this.windowOpen = false;
            this.sound.play('lgg', { volume: 0.4 });
            this.game.events.emit('showCryptoCrash');
        });

        popup.setCloseCallback(() => {
            popup.destroy();
            popup.messageText.destroy();
            this.windowOpen = false;

            this.time.delayedCall(300, () => {
                const dialogue = new DialogueWindow(this, 10, 10);
                dialogue.setMultiDialogue([
                    ["Why didn't you ape my call, bro?", "question"],
                    ["You must not trust me anymore...", "sad"]
                ]);
            });
        });
    }

    // getInTheCrystal() {
    //     this.crystal = this.add.sprite(128, 120, "crystal");
    //     this.player.play("crystal", true); 
    // }

    animateRockDoor(level) {
        const door = this.slidingDoor;
        
        // Stop random hopping during sequence
        this.stopRandomHopping();
        
        this.tweens.add({
            targets: door,
            x: door.x + 40,
            duration: 3000,
            ease: 'Power1',
            onComplete: () => {
                // Change animation to happy5 without resetting other properties
                this.player.anims.play('happy5', true);
                
                this.time.delayedCall(1000, () => {
                    this.tweens.add({
                        targets: this.player,
                        x: 117,
                        y: 69,
                        duration: 1000,
                        ease: 'Power1',
                        onComplete: () => {
                            this.tweens.add({
                                targets: this.player,
                                alpha: 0,
                                duration: 500,
                                onComplete: () => {
                                    this.player.destroy();
                                    
                                    this.time.delayedCall(500, () => {
                                        if (this.currentMusic) {
                                            this.currentMusic.stop();
                                        }
                                        this.scene.start(level);
                                    });
                                }
                            });
                        }
                    });
                });
            }
        });

        this.tweens.add({
            targets: door,
            y: door.y + 2,
            duration: 100,
            yoyo: true,
            repeat: 29,
            ease: 'Sine.easeInOut'
        });
        
        if (!this.soundFx.success.isPlaying) {
            this.soundFx.success.play();
        }

        if (!this.soundFx.rockSlide.isPlaying) {
            this.soundFx.rockSlide.play();
        }
    }

    handleMenuAction(action) {
        switch(action) {
            case 'inventory':
                this.showInventory();
                break;
            case 'map':
                this.showMap();
                break;
            case 'settings':
                this.showSettings();
                break;
        }
    }

    showInventory() {
        // Implement inventory display
        console.log('Showing inventory');
    }

    showMap() {
        // Implement map display
        //('Showing map');
    }

    showSettings() {
        // Implement settings display
        //console.log('Showing settings');
    }

    cleanup() {
        // Remove event listener when scene changes
        this.game.events.off('menuAction', this.handleMenuAction, this);
    }
/* END-USER-CODE */

}
/* END OF COMPILED CODE */
